import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { API_CONSTANTS } from '../../../utils/constants';
import { ApiResponse } from '../../../model';

import type { EmailNotificationDetail } from './model';

export const emailNotificationsApi = createApi({
  reducerPath: 'emailNotificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['EmailNotification'],
  endpoints: (build) => ({
    getEmailNotificationDetail: build.query<
      ApiResponse<EmailNotificationDetail>,
      string
    >({
      query: (templateId) => ({
        url: API_CONSTANTS.EMAIL_NOTIFICATIONS.DETAIL_URL(templateId),
        method: 'GET',
      }),
      providesTags: (_result, _error, templateId) => [
        { type: 'EmailNotification', id: templateId },
      ],
    }),
    editEmailNotification: build.mutation<
      ApiResponse<EmailNotificationDetail>,
      { id: string; subject?: string; bodyHtml?: string; status?: string }
    >({
      query: (body) => ({
        url: API_CONSTANTS.EMAIL_NOTIFICATIONS.EDIT_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'EmailNotification', id },
        { type: 'EmailNotification', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useLazyGetEmailNotificationDetailQuery,
  useEditEmailNotificationMutation,
} = emailNotificationsApi;

export default emailNotificationsApi;
